import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewParametroEngordeRacion = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'parametro_engorde_racion',
        name: 'Parametro engorde racion',
        component: ViewParametroEngordeRacion,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
